<script setup>
import CardBox from '@/components/CardBox.vue'
import BaseLevel from '@/components/BaseLevel.vue'
// import BaseIcon from '@/components/BaseIcon.vue'
import BaseButtons from '@/components/BaseButtons.vue'
import BaseButton from '@/components/BaseButton.vue'
import { onBeforeMount, ref, computed } from 'vue'

import { mdiAccessPoint, mdiEyeOutline } from '@mdi/js';
import { parseTimestamp } from '@/timestamp-options'
import CardBoxViolation from '@/components/Violations/CardBoxViolation.vue'
import { useViolationsStore } from '@/stores/violations'

const violationsStore = useViolationsStore()

const props = defineProps({
  notification: {
    type: Object,
    required: true
  },
  // canComplete: {
  //   type: Boolean,
  //   default: true
  // },
  // canTake: {
  //   type: Boolean,
  //   default: true
  // }
})

// const violation = ref(0)
const violation = computed(() => violationsStore.violation)

const isModalViolationActive = ref(false)

onBeforeMount(() => {
  if (props.notification.type === 'violation'){
    violationsStore.fetchViolation(props.notification.kwargs.id)
  }
})

</script>

<template>

  <CardBox>
    <CardBoxViolation
      v-if="notification.type === 'violation' && isModalViolationActive"
      :violation="violation"
      @close="isModalViolationActive=false"
    />
    <BaseLevel mobile>
      <div>
        <h1 class="text-2xl">
          {{ notification.type === "common" ? notification.text: notification.kwargs.title }}
        </h1>
        <template v-if="notification.type === 'everyday_stat'">
          <div v-for="product in notification.kwargs.products" :key="product.id">
            <span>{{ product.title }}:</span>
            <div v-for="wt in product.wts" :key="wt.id" class="ml-3">
              <span>{{ wt.title }} - {{ wt.amount }} {{ wt.unit }}</span>
            </div>
          </div>
        </template>
        <template v-else-if="notification.type === 'violation'">
          <p>Уровень: {{ notification.kwargs.display_type }}</p>
          <p>Описание: {{ notification.kwargs.description }}</p>
        </template>
      </div>
    </BaseLevel>
    <footer>
      <span class="flex justify-end items-center mt-2">
        <span class="mr-3">{{parseTimestamp(notification.created)}}</span>
        <BaseButtons type="justify-start" no-wrap>
          <BaseButton
            v-if="notification.type === 'violation'"
            color="info"
            :icon="mdiEyeOutline"
            small
            @click="isModalViolationActive=true"
          />
          <BaseButton
            :color="!notification.read ? 'warning': 'info'"
            :icon="mdiAccessPoint"
            small
          />
        </BaseButtons>
      </span>
    </footer>
  </CardBox>
</template>
